<template>
  <v-dialog v-model="addDialog" class="the-app-dialogs" persistent max-width="700px">
    <v-card>
      <form @submit.prevent="validateBeforeSubmit()">
        <v-layout row class="no-select" style="background-color:#09132f">
          <h3 id="dialog-title" class="text-uppercase px-3 pt-3" style="text-xs-center letter-spacing:2px">
            <v-layout align-center>
              <v-icon light x-large class="rgba(0,0,0,0.3)--text pb-1">fa-dolly</v-icon>
              <span class="px-3">{{ $t('Add New Wight Auditor') }}</span>
            </v-layout>
          </h3>
          <v-spacer />
          <v-card-actions>
            <v-btn fab icon dark @click="$emit('hidemodal')">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-actions>
        </v-layout>

        <v-card-title class="grey lighten-3">
          <v-layout column>
            <v-flex xs12 class="headline no-select pb-1">
              <v-layout justify-end></v-layout>
            </v-flex>

            <v-layout row wrap>
              <v-flex xs6 pa-2>
                <v-menu v-model="dateModal" full-width max-width="290" :close-on-content-click="false">
                  <v-text-field
                    id="weight-focus-me"
                    slot="activator"
                    :value="form.date"
                    :label="`${$t('Date')} *`"
                    prepend-inner-icon="event"
                    box
                    readonly
                    hide-details
                    name="Date"
                    background-color="white"
                    autocomplete="off"
                    :error="errors.has('Date')"
                    v-validate="'required|date_format:yyyy-MM-dd'"
                  />
                  <v-date-picker @change="dateModal = false" v-model="form.date" />
                </v-menu>
              </v-flex>

              <v-flex xs6 pa-2>
                <v-autocomplete
                  :items="shiftTimes"
                  v-model="form.shift_time"
                  :label="`${$t('Shift Time')} *`"
                  box
                  hide-details
                  :error="errors.has('Shift Time')"
                  v-validate="'required'"
                  background-color="white"
                  data-vv-name="Shift Time"
                  :menu-props="{ transition: 'slide-y-transition' }"
                />
              </v-flex>

              <v-flex xs6 pa-2>
                <v-autocomplete
                  :items="weightAuditorTypes"
                  v-model="form.type"
                  :label="`${$t('Type')} *`"
                  box
                  hide-details
                  :error="errors.has('Type')"
                  v-validate="'required'"
                  background-color="white"
                  data-vv-name="Type"
                  :menu-props="{ transition: 'slide-y-transition' }"
                />
              </v-flex>

              <v-flex xs6 pa-2>
                <v-autocomplete
                  :items="fullFactoriesList"
                  v-model="form.factory_id_fk"
                  :label="`${$t('Factory')} *`"
                  box
                  hide-details
                  :error="errors.has('Factory')"
                  background-color="white"
                  data-vv-name="Factory"
                  v-validate="'required'"
                  :menu-props="{ transition: 'slide-y-transition' }"
                />
              </v-flex>
            </v-layout>
          </v-layout>
        </v-card-title>
        <v-divider light />

        <v-card-actions class="grey lighten-3">
          <v-layout column>
            <v-flex xs12 class="pb-2 px-2" style="color: #444;"
              >- {{ $t('Fields marked with asterisk ( * ) are required.') }}</v-flex
            >

            <v-layout justify-end align-center pr-2 pl-2>
              <v-checkbox color="primary" v-model="keepForm" :label="$t('Keep this form to add another one.')" />

              <v-btn outline color="primary" @click="$emit('hidemodal')">{{ $t('Cancel') }}</v-btn>
              <v-btn type="submit" color="success" :loading="btnAddLoading">
                <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">save</v-icon>
                {{ $t('Add') }}
              </v-btn>
            </v-layout>
          </v-layout>
        </v-card-actions>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'add-component',

  props: {
    addDialog: { type: Boolean, required: true }
  },

  data() {
    return {
      btnAddLoading: false,
      form: {
        date: ''
      },
      dateModal: false,
      keepForm: false
    }
  },

  computed: {
    ...mapGetters({
      shiftTimes: 'productions/getShiftTimes',
      weightAuditorTypes: 'weightAuditors/getWeightAuditorTypes',
      fullFactoriesList: 'factories/getFullFactoriesList'
    })
  },

  watch: {
    addDialog: {
      immediate: false,
      handler() {
        if (this.addDialog) {
          this.addEscKeyListener()
          this.resetForm()
          this.keepForm = false
        }
      }
    }
  },

  methods: {
    ...mapActions({
      addWeightAuditor: 'weightAuditors/addWeightAuditor'
    }),

    addEscKeyListener() {
      document.addEventListener('keyup', e => {
        // if the "ESC" button was pressed and this dialog is shown, hide it
        if (e.keyCode === 27 && this.addDialog) {
          this.$emit('hidemodal')
        }
      })
    },

    resetForm() {
      this.$validator.pause()
      for (let key in this.form) {
        this.form[`${key}`] = null
      }
      this.form.date = this.$moment()
        .format()
        .substr(0, 10)
      this.$nextTick(() => {
        this.$validator.resume()
        // default veutify autofocus only one time works so we have to handled in this way.
        // document.getElementById('weight-focus-me').focus()
      })
    },

    validateBeforeSubmit() {
      this.$validator
        .validateAll()
        .then(() => {
          if (!this.errors.any()) {
            this.btnAddLoading = true

            this.addWeightAuditor(this.form)
              .then(() => {
                this.btnAddLoading = false
                this.$emit('reset-datatable')
                if (this.keepForm) {
                  this.resetForm()
                } else {
                  this.$emit('hidemodal')
                }
              })
              .catch(() => {
                this.btnAddLoading = false
              })
          }
        })
        .catch(() => {
          this.btnAddLoading = false
        })
    }
  }
}
</script>

<style scoped />
